import { print, type DocumentNode } from "graphql";

export const gqlClient = async <QueryResult>({
  query,
  variables,
  token,
}: {
  query: DocumentNode;
  variables?: Record<string, unknown>;
  token?: string;
}) => {
  const res = await $fetch<QueryResult>(`/api/graphql`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: {
      query: print(query),
      variables,
      token,
    },
  });
  return res;
};
